import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Avatar,
  Link,
  IconButton,
  Collapse,
} from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import theme from "../theme";
import Nate from "../Asset/Images/Nate.png";
// import Placeholder from "../Asset/Images/Placeholder.svg"; // Add a placeholder image in assets
import Jon from "../Asset/Images/Fellows/Jon.png";
import Karac from "../Asset/Images/Fellows/Karac.svg";
import Rosie from "../Asset/Images/Fellows/Rosie.svg";
import Rusham from "../Asset/Images/Fellows/Rusham.svg";
import FellowCard from "./FellowCard";
// import Clay from "../Asset/Images/Fellows/Clay.svg";
import Caroline from "../Asset/Images/Fellows/Caroline.svg";
// import Placeholder from "../Asset/Images/Placeholder.svg"; // Add a placeholder image in assets
//Advisory
import Anik from "../Asset/Images/Advisory/Anik Choudhry.svg";
import Charmaine from "../Asset/Images/Advisory/Charmaine Lykins.svg";
import David from "../Asset/Images/Advisory/David Henkin.svg";
import David2 from "../Asset/Images/Advisory/David Stodden.svg";
import Eleonora from "../Asset/Images/Advisory/Eleonora Orloff.svg";
import Jim from "../Asset/Images/Advisory/Jim LaChance.svg";
import Jorge from "../Asset/Images/Advisory/Jorge Pinedo.svg";
import Kenyokee from "../Asset/Images/Advisory/Kenyokee Crowell.svg";
import Mark from "../Asset/Images/Advisory/Mark Schweitzer.svg";
import MichaelG from "../Asset/Images/Advisory/Michael Gaizuitis.svg";
// import MichaelP from "../Asset/Images/Advisory/Michael Poku.png";
import MichaelR from "../Asset/Images/Advisory/Michael Rosenberger.svg";
// import Nicole from "../Asset/Images/Advisory/Nicole Connery.svg";
import Prateek from "../Asset/Images/Advisory/Prateek Maitra.png";
import Robert from "../Asset/Images/Advisory/Robert.svg";
import Tara from "../Asset/Images/Advisory/Tara Leweling.svg";
import Tom from "../Asset/Images/Advisory/Tom Hogan.svg";
import Anthony from "../Asset/Images/Fellows/Anthony.png";
import Olivia from "../Asset/Images/Fellows/Olivia.png";
import Tristan from "../Asset/Images/Fellows/Tristan.png";
import Omesha from "../Asset/Images/Fellows/Omesha.png";

const teamMembers = [
  { name: "Anthony Williams", role: "", image: Anthony, year: "2026" },
  { name: "Olivia Wong", role: "", image: Olivia, year: "2026" },
  { name: "Tristan Doyle", role: "", image: Tristan, year: "2026" }, 
  { name: "Omesha Singh", role: "", image: Omesha, year: "2026" },
  {
    name: "Jon Zebitsch",
    role: "Operating Partners",
    image: Jon,
    year: "2025",
  },
  {
    name: "Rosie Seidenberg",
    role: "Venture Fellow '25",
    image: Rosie,
    year: "2025",
  },
  {
    name: "Rusham Katoch",
    role: "Venture Fellow '24",
    image: Rusham,
    year: "2024",
  },
  {
    name: "Karac Webb",
    role: "Venture Fellow '24",
    image: Karac,
    year: "2024",
  },
];

const investors = [
 
  {
    name: "Caroline Krystoff",
    role: "",
    image: Caroline,
    year: "",
  },
  //  {
  //   name: "Clay Stanley",
  //   role: "",
  //   image: Clay,
  //   year: "",
  // },
];

const advisory = [
  { name: "David Henkin", role: "", image: David },
  { name: "Prateek Maitra", role: "", image: Prateek },
  { name: "Michael Rosenberger", role: "", image: MichaelR },
  // { name: "Nicole Connery", role: "", image: Nicole },
  { name: "Charmaine Lykins", role: "", image: Charmaine },
  { name: "Jim LaChance", role: "", image: Jim },
  { name: "Mark Schweitzer", role: "", image: Mark },
  // { name: "Anik Choudhry", role: "", image: Anik },
  // { name: "Tara Leweling", role: "", image: Tara },
  // { name: "David Stodden", role: "", image: David2 },
  // { name: "Michael Gaizuitis", role: "", image: MichaelG },
  // { name: "Jorge Pinedo", role: "", image: Jorge },
  // { name: "Eleonora Orloff", role: "", image: Eleonora },
  // { name: "Kenyokee Crowell", role: "", image: Kenyokee },
  { name: "Robert O’Connor", role: "", image: Robert },
  // { name: "Tom Hogan", role: "", image: Tom },
  // { name: "Michael Poku", role: "", image: MichaelP },
];

const Team = () => {
  const Placeholder = null;
  const [expanded, setExpanded] = useState(false);

  const handleReadMore = () => {
    setExpanded((prev) => !prev);
  };
  return (
    <Box
      id="Team"
      sx={{
        background: "#F3F8FE",
        py: { md: 2, sm: 2, xs: 2 },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Typography
        variant="h4"
        align="center"
        sx={{
          fontWeight: 600,
          letterSpacing: 1,
          fontFamily: theme.fonts.secondary,
          color: theme.palette.primary.main,
        }}
      >
        Team
      </Typography>

      <Box sx={{ p: { xs: 3, md: 6 }, borderRadius: 2, maxWidth: "1300px" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            color: theme.palette.secondary.main,
            mb: 1,
          }}
        >
          Managing General Partner
        </Typography>
        <Grid container spacing={4} alignItems="flex-start">
          {/* Image */}
          <Grid
            item
            xs={12}
            sm={3}
            md={3}
            sx={{
              display: { xs: "flex", sm: "block" },
              justifyContent: { xs: "center", sm: "center", md:'center' },
            }}
          >
            <Avatar
              alt="Nate Kline"
              src={Nate}
              sx={{
                width: {md:200, sm:140, xs:150},
                height: {md:200, sm:140, xs:150},
                mt: { xs: 0, sm: 1 },
              }}
            />
          </Grid>

          {/* Text */}
          <Grid item xs={12} sm={9} md={9}>
            <Box display="flex" alignItems="center" gap={1} mt={1}>
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: theme.palette.primary.main }}
              >
                Nate Kline
              </Typography>
              <IconButton
                href="https://www.linkedin.com/in/natekline/" // replace with actual profile
                target="_blank"
                rel="noopener noreferrer"
                size="small"
                sx={{
                  bgcolor: "#0077b5",
                  color: "#fff",
                  "&:hover": { bgcolor: "#005582" },
                }}
              >
                <LinkedInIcon fontSize="small" />
              </IconButton>
            </Box>

            <Typography variant="body" mt={1} sx={{ color: "#1D4979" }}>              Nate Kline is The Wellness VC, a notably experienced executive,
              investor, and entrepreneur (5x founder, Inc 5000 honoree),
              boasting a multifaceted institutional finance career spanning more
              than two decades and a 6 continent network. As an expert
              strategist and award-winning visionary, he’s added value across
              every business sector, company size and stage, from fledgling
              startups to multinational conglomerates. Cistern Capital is a
              product of his personal passion for health and dedication to
              nurturing early-stage founders. 
            </Typography>

            <Collapse in={expanded}>
              <Box mt={1}>
              <Typography variant="body" mt={1} sx={{ color: "#1D4979" }}>                  Prior to Cistern, Nate was a recognized thought leader in real
                  estate investing as Co-Founder and Chief Investment Officer of
                  OneWall Communities. Previously, he led global consulting and
                  financial training engagements with his own firm and partners
                  after having spearheaded more than $20B of private equity and
                  M&A transactions at Fortress and Merrill Lynch.
                </Typography>

                <Typography variant="body" mt={1} sx={{ color: "#1D4979" }} paragraph>                  Nate is a proud graduate of the Schreyer Honors College, Smeal
                  College of Business and the Liberal Arts School at
                  Pennsylvania State University, where he graduated with Honors
                  and two degrees in 4 years (B.S. in Finance and B.A. in
                  Economics). While there, he co-founded the Nittany Lion Fund,
                  marking a significant milestone as the first
                  multimillion-dollar undergraduate student-managed hedge fund
                  in the US.
                </Typography>

                <Typography variant="body" mt={1} sx={{ color: "#1D4979" }} paragraph>                  Beyond his professional and academic achievements, Nate is a
                  devoted family man, living in Tribeca with his wife and two
                  daughters. He is passionate about outdoor pursuits and sports,
                  showing his competitive spirit in baseball and beach
                  volleyball. He also finds joy on the golf course, on skis, on
                  hiking trails, and in the kitchen, where he hones his culinary
                  skills.
                </Typography>
              </Box>
            </Collapse>

            <Box
              onClick={handleReadMore}
              sx={{
                mt: 1,
                display: "flex",
                alignItems: "center",
                color: theme.palette.secondary.main,
                cursor: "pointer",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                {expanded ? "Show less" : "Read more"}
              </Typography>
              <ArrowForwardIcon fontSize="small" sx={{ ml: 0.5 }} />
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ my: 10 }}>
          <Typography
            variant="h6"
            sx={{
              color: theme.palette.secondary.main,
              fontWeight: "bold",
              mb: 1,
            }}
          >
            Advisory Board
          </Typography>
          <Typography
            variant="body1"
            
            sx={{
              color: "#1D4979",
              mb: 5,
            }}
          >
            Supplemental expertise and networks supporting portfolio success
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            {advisory.map((fellow, index) => (
              <Box
                key={index}
                sx={{
                  width: {
                    xs: "50%", // 1 per row on extra-small
                    sm: "33.33%", // 3 per row on small
                    md: "33.33%", // 3 per row on medium
                    lg: "16.66%", // ✅ 6 per row on large screens
                  },
                  px: 1,
                  mb: 4,
                }}
              >
                <FellowCard
                  name={fellow.name}
                  year={fellow.year}
                  image={fellow.image}
                />
              </Box>
            ))}
          </Box>
        </Box>

        <Box  id="Investors" sx={{ py: 4 }}>
          <Typography
            variant="h6"
            sx={{
              color: theme.palette.secondary.main,
              fontWeight: "bold",
              mb: 3,
            }}
          >
            Analyst/Investor Relations
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            {investors.map((fellow, index) => (
              <Box
                key={index}
                sx={{
                  width: {
                    xs: "50%",
                    sm: "33.33%",
                    md: "33.33%",
                    lg: "16.66%",
                  },
                  px: 1,
                  mb: 4,
                }}
              >
                <FellowCard
                  name={fellow.name}
                  year={fellow.year}
                  image={fellow.image}
                />
              </Box>
            ))}
          </Box>
        </Box>

        <Box sx={{ my: 10 }}>
          <Typography
            variant="h6"
            sx={{
              color: theme.palette.secondary.main,
              fontWeight: "bold",
              mb: 3,
            }}
          >
            Venture Fellowship
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            {teamMembers.map((fellow, index) => (
              <Box
                key={index}
                sx={{
                  width: {
                    xs: "50%",
                    sm: "33.33%",
                    md: "33.33%",
                    lg: "16.66%",
                  },
                  px: 1,
                  mb: 4,
                }}
              >
                <FellowCard
                  name={fellow.name}
                  year={fellow.year}
                  image={fellow.image}
                />
              </Box>
            ))}
          </Box>
        </Box>

       
      </Box>
    </Box>
  );
};

export default Team;
